import page from '../../../components/page'
import {store} from "../../../store/store";
import {api} from "../../../common/config";
import {ajaxUtil} from "../../../common/AjaxUtil";
import {CommonUtil} from "../../../common/CommonUtil";

export default {
    name: 'overduemsg',
    components: {
        page
    },
    data() {
        return {
            msgList: [],
            idCard: store.func.getUserIdCard(),
            totalPage: 1,
            imgError: store.imgError,
            pageCount: 10,
            pageNo: 1,
            overdue: { //逾期消息详情
                num: 0, //未读数量
                list: [], //消息列表
            },
        }
    },
    watch: {
        $route() {
            this.getList();
        }
    },
    beforeMount() {
        store.message._this.navName="逾期消息";
        this.getList();
    },
    methods: {
        getList() {
            this.pageNo = this.$route.query.page || 1;
            var url = api.personalnews.overdueList.replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount)
                .replace('{idCard}', this.idCard);
            ajaxUtil.ajaxJson(url, null, "GET", (data) => {
                if (data.resultList != null) {
                    this.msgList = data.resultList;
                }
                this.totalPage = data.totalPage;
            }, null, this);
        },
        //翻页操作
        pageChange(pageNo) {
            CommonUtil.mergeQuery(this, {page: pageNo});
        },
        readed(status, id, item, index) {
            if (status === 2) return false;
            var url = api.personalnews.overdueUpdateStatus;
            ajaxUtil.ajaxJson(url, {id: id}, "POST", (data) => {
                item.status = 2;
                store.wrap.messageCount -= 1;
            }, null, this);
        },
    }


}
